import React, {useRef, useState} from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import ArtistSuggestionsItemBrowser from "./ArtistSuggestionsItemBrowser";
import ArtistSuggestionsItemEditor from "./ArtistSuggestionsItemEditor";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import ServerManager from "../../API/ServerManager";

const ArtistSuggestionsPage = ({isAddSubMode}) => {

    const [deleteConfirmDialogOpen, setDeleteConfirmDialogOpen] = useState(false)
    const [deleteSuggestionId, setDeleteSuggestionId] = useState(0)
    const baseRef = useRef(null);

    function renderItemEditor(key, props) {
        return <ArtistSuggestionsItemEditor
            {...props}
            key={key}
            onDeleteSuggestion={onDeleteSuggestion}
            onAcceptSuggestion={onAcceptSuggestion}
            onLinkSuggestion={onLinkSuggestion}
        />
    }

    function onDeleteSuggestion(id) {
        setDeleteSuggestionId(id);
        setDeleteConfirmDialogOpen(true);
    }

    async function onAcceptSuggestion(suggestionId, authorData) {
        baseRef.current.setLoadingOverlayData({title: "Добавление автора"});

        let addedId = 0;

        try {
            const responseData = await ServerManager.addSimpleModeItem("artist", { ...authorData, suggestion_id: suggestionId });
            addedId = responseData.id;
            console.log("added artist Id", addedId);
        } catch (error) {
            baseRef.current.setLoadingOverlayData(null);
            baseRef.current.setSnackbarData({severity: "error", title: "Ошибка при добавлении автора!", message: error});
            return;
        }

        // успешно добавлено

        baseRef.current.setLoadingOverlayData(null);
        baseRef.current.setSnackbarData({severity: "success", message: "Автор добавлен, заявка исполнена"});
        //baseRef.current.setSnackbarData({severity: "success", message: "Заявка удалена"});
        baseRef.current.refreshBrowserItems();
        baseRef.current.setEditItemId(0);
    }

    async function onLinkSuggestion(suggestionId, linkedArtistId) {
        baseRef.current.setLoadingOverlayData({title: "Связывание с автором"});

        try {
            await ServerManager.resolveArtistSuggestion(suggestionId, linkedArtistId);
        } catch (error) {
            baseRef.current.setLoadingOverlayData(null);
            baseRef.current.setSnackbarData({severity: "error", title: "Ошибка при привязке к автору!", message: error});
            return;
        }

        // success

        baseRef.current.setLoadingOverlayData(null);
        baseRef.current.setSnackbarData({severity: "success", message: "Привязка к автору выполнена, заявка исполнена"});
        //baseRef.current.setSnackbarData({severity: "success", message: "Заявка удалена"});
        baseRef.current.refreshBrowserItems();
        baseRef.current.setEditItemId(0);
    }

    async function performDeleteSuggestion() {
        baseRef.current.setLoadingOverlayData({title: "Удаление заявки"});

        let deleted = false;

        try {
            const response = await ServerManager.deleteArtistSuggestion(deleteSuggestionId);
            deleted = true;
        } catch (error) {
            baseRef.current.setSnackbarData({severity: "error", title: "Ошибка при удалении заявки!", message: error});
        }

        baseRef.current.setLoadingOverlayData(null);

        if (deleted) {
            baseRef.current.setSnackbarData({severity: "success", message: "Заявка удалена"});
            baseRef.current.refreshBrowserItems();
            baseRef.current.setEditItemId(0);
        }
    }

    return (
        <>
            <BaseSimplePage
                ref={baseRef}
                isAddSubMode={isAddSubMode}
                modeApiName1="artist_suggestion"
                modeApiName2="artist_suggestions"
                ItemBrowserComponent={ArtistSuggestionsItemBrowser}
                renderItemEditorFunc={renderItemEditor}
            />
            <ConfirmDialog
                open={deleteConfirmDialogOpen}
                fullWidth={true}
                maxWidth={"xs"}
                message="Удалить заявку?"
                confirmLabel="Да"
                cancelLabel="Нет"
                onAnswer={confirmed => {
                    setDeleteConfirmDialogOpen(false);
                    if (confirmed)
                        performDeleteSuggestion();
                }}
            />
        </>
    );
};

export default ArtistSuggestionsPage;